import { Stack } from '@guestyci/arc';
import { utils } from 'utils';
import SocialLogin from './SocialLogin';
import HostsLink from './HostsLink';
import RegistrationLink from './RegistrationLink';

export const AppAdditionalContent = ({ onGoogleSignIn, isSubmitting, isWidgetRendered, showGoogleLogin }) => {
    if (utils.isHQDomain || utils.isAcademyDomain) {
        return null;
    }
    return ( 
      <>
        <SocialLogin
          onGoogleSignIn={onGoogleSignIn}
          disabled={isSubmitting || !isWidgetRendered}
          showGoogle={showGoogleLogin}
        />
        <Stack spacing={2} direction="column" className="gst-pt-2">
          <RegistrationLink />
          <HostsLink />
        </Stack>
      </>
    )
}

export default AppAdditionalContent;